import { defineStore } from "pinia";
import { api } from "@/shared/resource/apis/baseApi";
import { ROUTE } from "@/shared/resource/apis/endpoints";

export const useRouteStore = defineStore("route", {
  actions: {
    async addRoute(payload) {
      const response = await api.post(ROUTE.POST, payload);
      return response.data;
    },

    async updateRoute(id, payload) {
      const response = await api.put(ROUTE.UPDATE(id), payload);
      return response.data;
    },

    async deleteRoute(id) {
      const response = await api.delete(ROUTE.DELETE(id));
      return response.data;
    },

    async addFare(busId, routeId, fares) {
      const response = await api.patch(ROUTE.ADD_FARE, {
        bus_id: busId,
        route_id: routeId,
        fares: fares,
      });
      return response.data;
    },

    async addTrips(busId, routeId, trips) {
      const response = await api.post(ROUTE.ADD_TRIPS, {
        bus_id: busId,
        route_id: routeId,
        trips: trips,
      });
      return response.data;
    },

    deleteTrip(tripId) {
      const response = api.delete(ROUTE.DELETE_TRIP(tripId));
      return response.data;
    },

    async getTripTimeTable(routeId) {
      const response = await api.get(ROUTE.GET_TIME_TABLE(routeId));
      return response.data;
    },
  },
});
